module.exports = __webpack_public_path__ + "static/media/light_icn_map_fermata_scambio.755858a9.svg";